import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Maths is purdiful",
  "description": "",
  "published": "2010-02-04T00:00:00.000Z",
  "redirect_from": ["/blog/maths-is-purdiful/swizec/1165"],
  "categories": "Butterfly Curve, intrigues, Mathematics, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This whole week I've been doing a lot of maths studying. Things like `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Parametric_equation",
        "title": "Parametric equation"
      }}>{`parametric curves`}</a>{`, LaGrange theorems and funky functional sequences.`}</p>
    <p>{`Naturally I've developed a bit of a love for pretty mathematical objects, so I wanted to share some with you.`}</p>
    <ol>
      <li parentName="ol">{`Our first contestant is the `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Cardioid",
          "title": "Cardioid"
        }}>{`cardioid`}</a>{`. She's a bit chubby on the sides but has a heart of gold.`}</li>
    </ol>
    <p><a parentName="p" {...{
        "href": "http://www.wolframalpha.com/input/?i=plot+r+%3D+1-cosPhi+for+Phi+in+0,2Pi"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/02/Screen-shot-2010-02-04-at-6.09.19-PM.png",
          "alt": "Cardioid",
          "title": "Cardioid"
        }}></img></a></p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`The second contestant is an implicit heart and was contributed by a bloke on Facebook whom I believe has had this saved somewhere because it would be just mindblowing if he even know it from heart, let alone could create it.`}</li>
    </ol>
    <p><a parentName="p" {...{
        "href": "http://www.wolframalpha.com/input/?i=plot+(x2+%2B+y2+-+1)3+-+x2+*+y3+%3D+0"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/02/Screen-shot-2010-02-04-at-6.11.36-PM.png",
          "alt": "Implicit heart",
          "title": "Implicit heart"
        }}></img></a></p>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`This little nugget followed from my experimentation with parameters of a curve I don't know the name of ... it's a flower if you haven't noticed.`}</li>
    </ol>
    <p><a parentName="p" {...{
        "href": "http://www.wolframalpha.com/input/?i=plot+r+%3D+cos(12Phi)+for+Phi+in+0,2Pi"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/02/Screen-shot-2010-02-04-at-6.13.41-PM.png",
          "alt": "Flower",
          "title": "Flower"
        }}></img></a></p>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`The Butterfly Curve is well known in some circles, but I found it by stumbling around wikipedia like a drunken madman`}</li>
    </ol>
    <p><a parentName="p" {...{
        "href": "http://www.wolframalpha.com/input/?i=plot+r%3De(sin(Phi))-2*cos(4(Phi))%2Bsin((2*Phi-Pi)/24)5+for+Phi+in+0,20Pi"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/02/Screen-shot-2010-02-04-at-6.15.31-PM.png",
          "alt": "Butterfly Curve",
          "title": "Butterfly Curve"
        }}></img></a></p>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">{`There are likely to be other contestants I have yet to discover.`}</li>
    </ol>
    <p>{`So, which curve do you think is the most beautifulest mathematical construct?`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/69e2cbc2-ea5f-4ce2-bd1d-b877619943c5/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=69e2cbc2-ea5f-4ce2-bd1d-b877619943c5",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      